import {ActionContext} from 'vuex';
import {getAttachments, getMix} from '@/api/order';
import _ from 'lodash';
import Vue from 'vue';
import request from "@/util/request";
import {formatDate} from '@/formatDate';


function tempAccurate(value, number) {
    const point = number > 0 ? number : 0;
    if (point > 0) {
        const roundValue = Math.round(parseFloat(value) * Math.pow(10, point));
        const value2 = roundValue / Math.pow(10, point);
        return value2;
    } else {
        return Math.round(parseFloat(value));
    }
}

const initState = {
    allLoading: true,
    error: null,
    data: {
        id: 0,
        createdAt: null,
        num: '',
        desc: '',
        disPlayImgUrl: '',
        styleNo: '',
        price: 0,
        currencyUnit: '',
        quantity: 0,
        deliveryDate: null,
        attachments: [],
        users: [],
    },
    qtyTable: [],
    poList: [],
    boms: [],
    factoryList: [],
    clothesStuffList: [],
    clothesStuffDeliveries: [],
    processes: [],
    poPacks: [],
    exchangeRates: [],
    budgetCosts: [],
    lastBudgetDetail: {}, //上一次成功审批的结果信息
    orderStatus: '',
    laterTimes:[],
};

const fabricCompareParams = [
    {name: '名称', key: 'name', default: ''},
    {name: '供应商', key: 'vendorId', default: ''},
    {name: '单耗', key: 'consumption', default: 0},
    {name: '单位', key: 'unitType', default: ''},
    {name: '总成本', key: 'totalCost', default: 0},
    {name: '总数量', key: 'totalQuantity', default: 0},
    {name: '单价', key: 'unitCost.amount', default: 0},
    {name: '货币单位', key: 'unitCost.currency', default: ''},

];

const accessoryCompareParams = [
    {name: '名称', key: 'name', default: ''},
    {name: '单耗', key: 'consumption', default: 0},
    {name: '单位', key: 'unitType', default: ''},
    {name: '总成本', key: 'totalCost', default: 0},
    {name: '总数量', key: 'totalQuantity', default: 0},
    {name: '单价', key: 'unitCost.amount', default: 0},
    {name: '货币单位', key: 'unitCost.currency', default: ''},
    {name: '供应商', key: 'vendorId', default: ''}
];

const processCompareParams = [
    {name: '名称', key: 'name', default: ''},
    {name: '总成本', key: 'totalCost', default: 0},
    {name: '总数量', key: 'totalQuantity', default: 0},
    {name: '单价', key: 'unitCost.amount', default: 0},
    {name: '货币单位', key: 'unitCost.currency', default: ''},
    {name: '供应商', key: 'vendorId', default: ''}
];
const processingPlantParams = [
    {name: '生产数量', key: 'totalQuantity', default: 0},
    {name: '成本', key: 'totalCost', default: 0},
    {name: '单价', key: 'unitCost.amount', default: 0},
    {name: '货币单位', key: 'unitCost.currency', default: ''},

];

function countLaterTime() {
    const date = new Date();
    const min = date.getMinutes();
    date.setMinutes(min + 5);
    return formatDate(new Date(date.setMinutes(min + 5)), 'yyyy-MM-dd hh:mm:ss');
}

function theVendorName(value, factoryInOrders, vendorList) {
    const factoryId = _.chain(factoryInOrders as Array<{ id: number, factoryId: string }>).find({id: value}).get('factoryId', null).value();
    return _.chain(vendorList as Array<{ uuid: string, name: string }>).find({uuid: factoryId}).get("name", "未知").value();
}


function compareListAndCreateDesc(tag, compareParams, currentList, lastList, vendorList) {

    const deleteList: string[] = [];
    const createList: string[] = [];
    const updateList: string[] = [];
    _.each(lastList, item => {
        const sameIndex = _.findIndex(currentList, {refTo: item.refTo});
        if (sameIndex == -1) {
            //说明某材料没有了
            deleteList.push("删除了" + tag + ":" + item.name);
        }
    })
    _.each(currentList, item => {
        const sameIndex = _.findIndex(lastList, {refTo: item.refTo});
        if (sameIndex > -1) {
            let updateDesc = tag + "【" + item.name + "】";
            let update = false;
            //是同材料，可以比对，可能修改了

            _.each(compareParams, param => {
                // @ts-ignore
                if (_.get(item, param.key, param.default) !== _.get(lastList[sameIndex], param.key, param.default)) {
                    update = true;
                    //不管是否相等都可以处理下
                    if (param.key !== 'vendorId') {
                        let toValue = _.get(item, param.key, param.default);
                        if (_.isNumber(toValue)) {
                            //是数字的话注意处理
                            toValue = tempAccurate(toValue, 3);
                        }
                        // @ts-ignore
                        updateDesc = updateDesc + [param.name] + "改为:" + toValue + ",";
                    } else {
                        updateDesc = updateDesc + [param.name] + "改为:" + _.chain(vendorList as Array<{ uuid: string, name: string }>).find({uuid: item.vendorId}).get('name', '空').value();
                    }

                } else {
                    // console.log('比较结果一个是'+_.get(item, param.key, param.default)+"一个是:"+_.get(lastList[sameIndex], param.key, param.default));
                }
            })
            if (update) {
                updateList.push(updateDesc);
            }
        } else {
            //这是一个新材料
            createList.push("新增了材料:" + item.name);
        }
    })

    // console.log(deleteList);
    // console.log(createList);
    // console.log(updateList);
    return deleteList.join(",") + createList.join(",") + updateList.join(",");
}

function compareFactoryChange(currentList, lastList, factoryInOrders, vendorList) {
    const deleteList: string[] = [];
    const createList: string[] = [];
    const updateList: string[] = [];
    _.each(lastList, item => {
        const sameIndex = _.findIndex(currentList, {refTo: item.refTo})
        if (sameIndex == -1) {
            //虽然这里知道进行了删除加工厂的操作..但是，根本不知道是删了哪个加工厂，
            deleteList.push("删除了加工厂");
            //这里的refTo指向的是factoryInOrder，
        }
    })
    _.each(currentList, item => {
        const sameIndex = _.findIndex(lastList, {refTo: item.refTo});
        if (sameIndex > -1) {
            let updateDesc = "加工厂【" + theVendorName(item.refTo, factoryInOrders, vendorList) + "】";
            let update = false;
            _.each(processingPlantParams, param => {
                // @ts-ignore
                if (_.get(item, param.key, param.default) !== _.get(lastList[sameIndex], param.key, param.default)) {
                    update = true;
                    //不管是否相等都可以处理下

                    let toValue = _.get(item, param.key, param.default);
                    if (_.isNumber(toValue)) {
                        //是数字的话注意处理
                        toValue = tempAccurate(toValue, 3);
                    }

                    updateDesc = updateDesc + [param.name] + "改为:" + toValue + ",";
                }
            })
            if (update) {
                updateList.push(updateDesc);
            }
        } else {
            //这是一个新材料
            createList.push("新增了加工厂:" + theVendorName(item.refTo, factoryInOrders, vendorList));
        }
    })

    return deleteList.join(",") + createList.join(",") + updateList.join(",");
}


function compareBudget(currentBudget, lastBudget, factoryInOrderList, vendorList) {
    const str1 = compareListAndCreateDesc("面料", fabricCompareParams, currentBudget.fabrics, lastBudget.fabrics, vendorList);
    const str2 = compareListAndCreateDesc("辅料", accessoryCompareParams, currentBudget.accessories, lastBudget.accessories, vendorList);
    const str3 = compareListAndCreateDesc("工序", processCompareParams, currentBudget.processes, lastBudget.processes, vendorList);
    const str4 = compareFactoryChange(currentBudget.processingPlants, lastBudget.processingPlants, factoryInOrderList, vendorList);
    return str1 + str2 + str3 + str4;
}

function paramFileBubbleSort(arrayInput: any[]) {
    let length = arrayInput.length;
    for (let i = length; i >= 2; --i) {
        for (let j = 0; j < i - 1; ++j) {
            if (compareItemTime(arrayInput[j], arrayInput[j + 1])) {
                let temp = arrayInput[j];
                arrayInput[j] = arrayInput[j + 1];
                arrayInput[j + 1] = temp;
                //交换
            }
        }
    }
}

function compareItemTime(a: any, b: any) {
    if (a.dataPosition > b.dataPosition) {
        return true;
    } else if (a.dataPosition < b.dataPosition) {
        return false;
    } else {
        if (new Date(a.createdAt) > new Date(b.createdAt)) {
            return false;
        } else {
            return true;
        }
    }
}

function orderAttachDealChild(array: any) {
    if (array.length > 0) {
        array[0].isLast = true;
    }
    for (let i = 0; i < array.length - 1; i++) {
        if (array[i].dataPosition == array[i + 1].dataPosition) {
            array[i + 1].isLast = false;
        } else {
            array[i + 1].isLast = true;
        }
    }
}

function orderAttachDeal(attachments: any) {
    for (let i = 0; i < attachments.length; i++) {
        paramFileBubbleSort(attachments[i].orderParamFiles);
        orderAttachDealChild(attachments[i].orderParamFiles);
    }

}

function updateQtyTable(state: any, {qtyTable}: { qtyTable: any }) {
    if (qtyTable) {

        state.qtyTable.push(...qtyTable.inserted);
        _.each(qtyTable.deleted, (id) => {
            // const idx = _.findIndex(state.qtyTable, {id});
            // const factoryIdx = _.findIndex(state.qtyTable,{sizeDimId:state.qtyTable[idx].sizeDimId,colorDimId:state.qtyTable[idx].colorDimId,refTo:"FACTORY_IN_ORDER"});
            // // state.qtyTable.splice(idx, 1);
            // if(factoryIdx >-1){
            //   //
            //   console.log("这里直接根据尺码和颜色判断，导致把其他加工厂对应尺码的数量也改成了0",state.qtyTable[factoryIdx]);
            //     state.qtyTable[factoryIdx].quantity = 0;
            // }
            const ide = _.findIndex(state.qtyTable, {id});
            if(ide >-1){
                state.qtyTable.splice(ide, 1);
            }

        });
        _.each(qtyTable.updated, (qtyItem) => {
            const idx = _.findIndex(state.qtyTable, {id: qtyItem.id});
            state.qtyTable[idx].quantity = qtyItem.quantity;
        });

    }
    console.log('state.qtyTable :',state.qtyTable);
}

export default {
    namespaced: true,
    state: _.cloneDeep(initState),
    mutations: {
        deleteLaterTime(state: any, orderId: number){
            const idx = _.findIndex(state.laterTimes, {orderId});
            if (idx > -1) {
                state.laterTimes.splice(idx, 1);
            }
            console.log('state.laterTimes :',state.laterTimes);
        },
        setSubmitTime(state: any, orderId: number) {

            console.log('orderStatus :',state.orderStatus);
             if (state.orderStatus === '生产及以后') {
                 const laterTime =  countLaterTime();
                 const idx = _.findIndex(state.laterTimes, {orderId});
                 if (idx === -1) {
                     state.laterTimes.push({orderId,laterTime});
                 } else {
                     state.laterTimes[idx].laterTime = laterTime;
                 }
             }

        },
        setOrderStatus(state: any, status: string) {
            state.orderStatus = status;
        },
        setLastApprove(state: any, data: any) {
            state.lastBudgetDetail = data;
        },
        setOrderBase(state: any, order: any) {
            _.merge(state, _.cloneDeep(initState));
            _.merge(state.data, order);
            state.allLoading = false;
            state.error = null;
        },
        setError(state: any, error: string) {
            state.allLoading = false;
            state.error = error;
        },
        setAttachments(state: any, attachments: any) {
            orderAttachDeal(attachments);
            state.data.attachments = attachments;
        },
        setMix(state: any, {
            clothesStuffList, boms, qtyTable, poList, factoryList,
            clothesStuffDeliveries, poPacks, processes, exchangeRates, budgetCosts
        }: any) {
            Vue.set(state, 'factoryList', factoryList);
            Vue.set(state, 'clothesStuffList', clothesStuffList);
            Vue.set(state, 'poList', poList);
            Vue.set(state, 'qtyTable', qtyTable);


            Vue.set(state, 'boms', boms);
            Vue.set(state, 'clothesStuffDeliveries', clothesStuffDeliveries);

            Vue.set(state, 'poPacks', poPacks);
            Vue.set(state, 'processes', processes);
            Vue.set(state, 'exchangeRates', exchangeRates);
            Vue.set(state, 'budgetCosts', budgetCosts);
            Vue.set(state, 'budgetCosts', budgetCosts);
        },
        addBom(state: any, bom: any) {
            state.boms.push(bom);
        },
        deleteBom(state: any, bomId: number) {
            const bomIndex = _.findIndex(state.boms, {id: bomId});
            if (bomIndex > -1) {
                state.boms.splice(bomIndex, 1);
            }
        },
        setMainBom(state: any, bomId: number) {
            _.each(state.boms, (v, idx) => {
                state.boms[idx].isMain = state.boms[idx].id === bomId;
            });
        },
        addBudgetCost(state: any, budgetCost: any) {
            state.budgetCosts.push(budgetCost);
        },
        deleteBudgetCost(state: any, id: number) {
            const idx = _.findIndex(state.budgetCosts, {id});
            if (idx > -1) {
                state.budgetCosts.splice(idx, 1);
            }
        },
        updateBudgetCost(state: any, budgetCost: any) {
            const idx = _.findIndex(state.budgetCosts, {id: budgetCost.id});
            if (idx > -1) {
                _.merge(state.budgetCosts[idx], budgetCost);
            }
        },
        deleteExchangeRate(state: any, id: number) {
            const idx = _.findIndex(state.exchangeRates, {id});
            if (idx > -1) {
                state.exchangeRates.splice(idx, 1);
            }
        },
        addExchangeRate(state: any, data: any) {
            state.exchangeRates.push(data);
        },
        updateExchangeRate(state: any, data: any) {
            const idx = _.findIndex(state.exchangeRates, {id: data.id});
            if (idx > -1) {
                state.exchangeRates[idx].sourceCurrency = data.sourceCurrency;
                state.exchangeRates[idx].rate = data.rate;
            }
        },
        deletePo(state: any, po) {
            console.log('state.poList :',po,state.poList);
            const idx = _.findIndex(state.poList, {id: po.id});
            if (idx > -1) {
                state.poList.splice(idx, 1);
                _.each(state.qtyTable, item => {
                    const idx = _.findIndex(state.qtyTable, {refId: po.id});
                    const factoryIdx = _.findIndex(state.qtyTable,{sizeDimId:state.qtyTable[idx].sizeDimId,colorDimId:state.qtyTable[idx].colorDimId,refTo:"FACTORY_IN_ORDER"});
                    if(factoryIdx >-1){
                        state.qtyTable[factoryIdx].quantity = 0;
                    }
                    const ide = _.findIndex(state.qtyTable, {refId: po.id});
                    if (ide > -1) {
                        state.qtyTable.splice(ide, 1);
                    }
                });
            }
            console.log('state.qtyTable :',state.qtyTable);
        },
        moveDim(state: any, {bomId, dims}: { bomId: number, dims: Array<{ id: number, orderPos: number }> }) {
            const bomIndex = _.findIndex(state.boms, {id: bomId});
            if (bomIndex > -1) {
                _.each(dims, (dim) => {
                    const dimIndex = _.findIndex(state.boms[bomIndex].dims, {id: dim.id});
                    state.boms[bomIndex].dims[dimIndex].orderPos = dim.orderPos;
                });
            }
        },
        deleteDim(state: any, dimId: number) {
            const bomIndex = _.findIndex(state.boms, (bom: any) => _.findIndex(bom.dims, {id: dimId}) > -1);
            if (bomIndex > -1) {
                const idx = _.findIndex(state.boms[bomIndex].dims, {id: dimId});
                if (idx > -1) {
                    state.boms[bomIndex].dims.splice(idx, 1);
                }
            }

            const qtyTableCopy = _.cloneDeep(state.qtyTable);
            _.each(qtyTableCopy,poItem=>{
                if (poItem.sizeDimId == dimId || poItem.colorDimId == dimId) {
                    const poIndex = _.findIndex(state.qtyTable,{id : poItem.id});
                    if (poIndex > -1) {
                        state.qtyTable.splice(poIndex, 1);
                    }
                }

            })
        },
        addPo(state: any, po: any) {
            state.poList.push({
                id: po.id, name: po.name, unitPrice: po.unitPrice,
            });
            updateQtyTable(state, po);
        },
        //
        updatePo(state: any, po: any) {
            // updateQtyTable(state, po);

            console.log('po :',po);
            const idx = _.findIndex(state.poList, {id: po.id});
            updateQtyTable(state, po);
            state.poList[idx].name = po.name;
            state.poList[idx].unitPrice = po.unitPrice;


            //
            // updateQtyTable(state, po){
            //   if (po) {
            //     state.qtyTable.push(...po.inserted);
            //     _.each(po.deleted, (id) => {
            //       const idx = _.findIndex(state.qtyTable, {id});
            //       state.qtyTable.splice(idx, 1);
            //     });
            //     _.each(po.updated, (qtyItem) => {
            //       const idx = _.findIndex(state.qtyTable, {id: qtyItem.id});
            //       state.qtyTable[idx].quantity = qtyItem.quantity;
            //     });
            //   }
            //
            //
            // }


        },
        //delete
        deleteClothesStuff(state: any, id: number) {
            const idx = _.findIndex(state.clothesStuffList, {id});
            if (idx > -1) {
                state.clothesStuffList.splice(idx, 1);
            }
        },
        deleteOrderProcess(state: any, id: number) {
            const idx = _.findIndex(state.processes, {id});
            if (idx > -1) {
                state.processes.splice(idx, 1);
            }
        },
        deleteFactoryInOrder(state: any, id: number) {
            const idx = _.findIndex(state.factoryList, {id: id});
            if (idx > -1) {
                state.factoryList.splice(idx, 1);
            }
        },
        //
        addClothesStuff(state: any, stuff: any) {
            updateQtyTable(state, stuff);
            delete stuff.qtyTable;
            state.clothesStuffList.push({
                ...stuff,
            });
        },
        addProcess(state: any, process: any) {
            state.processes.push({
                ...process,
            });
        },
        addPoPacks(state: any, poPacks: any[]) {
            _.each(poPacks, (poPack) => {
                updateQtyTable(state, poPack);
                delete poPack.qtyTable;
                state.poPacks.push({
                    ...poPack,
                });
            });
        },
        updatePoPack(state: any, poPack: any) {
            const idx = _.findIndex(state.poPacks, {id: poPack.id});
            if (idx > -1) {
                _.merge(state.poPacks[idx], poPack);
            }
        },
        deletePoPack(state: any, packId: number) {
            let idx = _.findIndex(state.poPacks, {id: packId});
            if (idx > -1) {
                state.poPacks.splice(idx, 1);
            }

            while ((idx = _.findIndex(state.qtyTable, {refTo: 'PO_PACK', refId: packId})) > -1) {
                state.qtyTable.splice(idx, 1);
            }
        },
        updateClothesStuff(state: any, stuff: any) {
            updateQtyTable(state, stuff);
            const idx = _.findIndex(state.clothesStuffList, {id: stuff.id});
            delete stuff.qtyTable;
            _.merge(state.clothesStuffList[idx], stuff);
        },
        updateProcess(state: any, process: any) {
            const idx = _.findIndex(state.processes, {id: process.id});
            _.merge(state.processes[idx], process);
        },
        addClothesStuffDelivery(state: any, delivery: any) {
            updateQtyTable(state, delivery);
            delete delivery.qtyTable;
            state.clothesStuffDeliveries.push({
                ...delivery,
            });
        },
        updateClothesStuffDelivery(state: any, delivery: any) {
            updateQtyTable(state, delivery);
            const idx = _.findIndex(state.clothesStuffDeliveries, {id: delivery.id});
            delete delivery.qtyTable;
            _.merge(state.clothesStuffDeliveries[idx], delivery);
        },
        addFactory(state: any, factory: any) {
            updateQtyTable(state, factory);
            delete factory.qtyTable;
            state.factoryList.push({
                ...factory,
            });
        },
        updateFactory(state: any, factory: any) {
            updateQtyTable(state, factory);
            const idx = _.findIndex(state.factoryList, {id: factory.id});
            delete factory.qtyTable;
            _.merge(state.factoryList[idx], factory);
        },
        addDim(state: any, {bomId, newDim}: { bomId: number, newDim: any }) {
            const idx = _.findIndex(state.boms, {id: bomId});
            state.boms[idx].dims.push(newDim);
        },
        updateDim(state: any, {bomId, id, name}: { bomId: number, id: number, name: string }) {
            const idx = _.findIndex(state.boms, {id: bomId});
            const dimIdx = _.findIndex(state.boms[idx].dims, {id});
            state.boms[idx].dims[dimIdx].name = name;
        },
        updateBom(state: any, {bomId, id, name}: { bomId: number, id: number, name: string }) {
            const idx = _.findIndex(state.boms, {id: bomId});
            // const dimIdx = _.findIndex(state.boms[idx].dims, {id});
            state.boms[idx].name = name;
        },
    },
    actions: {
        async getAttachments({commit, state}: ActionContext<any, any>) {
            const attachments = await getAttachments(state.data.id);
            commit('setAttachments', attachments);
        },
        async getMix({commit, state}: ActionContext<any, any>) {
            const mix = await getMix(state.data.id);
            commit('setMix', mix);
        },
        // 单个订单数据重新获取的时候，
        async getLastApproveBudget({state, commit}, param) {
            if (param > 0) {
                //是个订单id
                const value = await request.get(`/gapi/order-budgets/last_approved_budget_by_order?orderId=` + param);
                if (value.status) {
                    commit('setLastApprove', value.data);
                    commit('setOrderStatus', '生产及以后');
                } else {
                    commit('setLastApprove', {});
                    commit('setOrderStatus', '计划中');
                }
            }

        },
        //
        compareBudgetChange({rootGetters, state, rootState}) {
            const currentBudget = rootGetters.orderBudget;
            const lastBudget = state.lastBudgetDetail;
            if (lastBudget && lastBudget.id) {
                const finalDesc = compareBudget(currentBudget, lastBudget, state.factoryList, rootState.vendors.list);
                if (finalDesc && finalDesc.length > 0) {
                    request.post('/api/operation_log', {
                        orderId: state.data.id,
                        tag: '订单修改',
                        content: finalDesc
                    })
                }


                //

            }
        }
    },
};
